import comp from "./AiQuestionLoader";
export default comp;
